import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

import type { DevelopmentSummaryModel } from '@/domain/models/development.js';

interface Props {
    label: string;
    options: DevelopmentSummaryModel[];
    value: DevelopmentSummaryModel | null;
    onChange: (value: DevelopmentSummaryModel | null) => void;
}

export function LinkedDevelopmentField({ label, options, value, onChange }: Props) {
    return (
        <Autocomplete
            options={options}
            value={value}
            onChange={(_, v) => onChange(v)}
            getOptionLabel={(d) => `${d.displayId} — ${d.title}`}
            isOptionEqualToValue={(a, b) => a.id === b.id}
            size="small"
            renderInput={(params) => <TextField {...params} label={label} />}
        />
    );
}
